import { Link } from 'react-router-dom';
import useScrollReveal from '../../hooks/useScrollReveal';
import useSeo from '../../hooks/useSeo';
import { ArrowRight } from 'lucide-react';

export default function About() {
    const revealRef = useScrollReveal();

    useSeo({
        title: 'Hakkımızda | Noora Privé - Zarif Kadın Giyim Markası',
        description: 'Noora Privé hikayesi. Zamansız şıklık, özgün tasarım ve kaliteli kumaşlarla kadın giyimde fark yaratan butik marka. Felsefemizi ve değerlerimizi keşfedin.',
        keywords: 'Noora Privé hakkında, noora prive, nooraprive, kadın giyim markası, butik moda, özgün tasarım, kaliteli kumaş, İzmir butik, online butik kadın giyim, zarif kadın giyim',
        canonical: 'https://nooraprive.com/hakkimizda'
    });

    return (
        <div className="np-about" ref={revealRef}>
            {/* Hero */}
            <section className="np-about-hero">
                <div className="np-about-hero-inner">
                    <span className="np-about-overtitle reveal">Hikayemiz</span>
                    <h1 className="reveal">
                        Zarafetin<br />Yeni Adresi
                    </h1>
                    <p className="reveal">
                        Her parçanın bir hikayesi var. Noora Privé, zamansız şıklığı
                        ve özgün tasarımı bir araya getirerek sizin için özel koleksiyonlar yaratıyor.
                    </p>
                </div>
            </section>

            {/* Philosophy - full width split */}
            <section className="np-about-split reveal">
                <div className="np-about-split-text">
                    <span className="np-about-label">Felsefemiz</span>
                    <h2>Moda Geçici,<br />Stil Kalıcı</h2>
                    <p>
                        Noora Privé, modayı bir sanat formu olarak gören bir ekibin
                        "herkes güzel hissedebilir" inancıyla kuruldu. Tasarım detaylarına
                        olan tutkumuz, bizi sektörde öne çıkardı.
                    </p>
                    <p>
                        Her koleksiyonumuzda kaliteli kumaşlara bağlılık ve zamansız
                        şıklığı ön planda tutuyoruz. Özenle seçilmiş, sınırlı sayıda
                        üretilen parçalarla fark yaratıyoruz.
                    </p>
                </div>
                <div className="np-about-split-visual">
                    <div className="np-about-split-img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=800&q=80)' }} />
                </div>
            </section>

            {/* Values - 3 col minimal */}
            <section className="np-about-values">
                <div className="np-about-values-inner">
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">01</span>
                        <h3>Özgün Tasarım</h3>
                        <p>Her parça, trendlerin ötesinde zamansız bir estetikle tasarlanıyor. Sizin için özel, sınırlı sayıda üretim.</p>
                    </div>
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">02</span>
                        <h3>Kaliteli Kumaşlar</h3>
                        <p>Doğal lifler, sürdürülebilir kaynaklar ve titizlikle seçilmiş kumaşlar. Her dokunuşta kaliteyi hissedin.</p>
                    </div>
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">03</span>
                        <h3>Kişisel Deneyim</h3>
                        <p>Stil danışmanlığımızla size özel öneriler sunuyoruz. Alışveriş öncesi ve sonrası her zaman yanınızdayız.</p>
                    </div>
                </div>
            </section>

            {/* Full width image banner */}
            <section className="np-about-banner reveal">
                <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1600&q=80" alt="Koleksiyon" />
                <div className="np-about-banner-overlay">
                    <blockquote>
                        "Zarafet, basitlikte gizlidir."
                    </blockquote>
                </div>
            </section>

            {/* Promises */}
            <section className="np-about-promises">
                <div className="np-about-promises-inner">
                    <div className="np-about-promises-head reveal">
                        <span className="np-about-label">Sözümüz</span>
                        <h2>Size Sunduğumuz<br />Değerler</h2>
                    </div>
                    <div className="np-about-promises-grid">
                        <div className="np-about-promise reveal">
                            <h4>Hızlı Teslimat</h4>
                            <p>Siparişleriniz özenle paketlenerek aynı gün kargoya verilir. Türkiye genelinde 1-3 iş günü.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Güvenli Alışveriş</h4>
                            <p>iyzico güvencesiyle ödeme. Kişisel bilgileriniz ve ödemeleriniz her zaman koruma altında.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Kolay İade</h4>
                            <p>Memnun kalmazsanız 14 gün içinde ücretsiz iade. Hiçbir soru sorulmadan.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Stil Danışmanlığı</h4>
                            <p>WhatsApp üzerinden kişisel stil önerileri alın. Kombinlerinizi birlikte oluşturalım.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="np-about-cta reveal">
                <div className="np-about-cta-inner">
                    <h2>Koleksiyonu Keşfedin</h2>
                    <p>Sezona özel parçalar ve yeni gelenler sizi bekliyor.</p>
                    <Link to="/urunler" className="np-about-cta-btn">
                        <span>Alışverişe Başla</span>
                        <ArrowRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
